import { StateData } from 'v2/data-store/data-store.types';

import { IChannel } from './../../shared/interfaces/mtchannel.interface';
import { IPagination } from './../../shared/interfaces/paginator.interface';

export interface IChannelState extends StateData {
  channels :IChannel[];
  currentChannel :IChannel | null;
  loading :boolean;
  meta :IPagination | null;
  submitting :boolean;
  currentQueryParams :{ [key :string] :string | string[] };
}

export interface IChannelHubspotDeal {
  portalId :number;
  dealId :number;
  isDeleted :boolean;
  hs_closed_amount_in_home_currency :string;
  dealname :string;
  num_associated_contacts :string;
  hs_num_associated_deal_registrations :string;
  createdate :string;
  hs_is_closed :string;
  hs_deal_stage_probability :string;
  days_to_close :string;
  hs_deal_stage_probability_shadow :string;
  hubspot_owner_id :string;
  hs_closed_amount :string;
  hs_created_by_user_id :string;
  hs_createdate :string;
  hs_projected_amount :string;
  hs_is_deal_split :string;
  hs_num_target_accounts :string;
  hs_all_owner_ids :string;
  hs_projected_amount_in_home_currency :string;
  hs_is_closed_won :string;
  closedate :string;
  hs_user_ids_of_all_owners :string;
  hs_num_associated_active_deal_registrations :string;
  pipeline :string;
  hs_lastmodifieddate :string;
  hubspot_owner_assigneddate :string;
  hs_num_associated_deal_splits :string;
  dealstage :string;
  hs_object_id :string;
  hs_updated_by_user_id :string;
  companies :IChannelCompany[];
  contacts :any[];
}

export interface IChannelCompany {
  portalId :number;
  companyId :number;
  isDeleted :boolean;
  country :string;
  num_associated_contacts :string;
  city :string;
  shipping_city :string;
  hs_pipeline :string;
  description :string;
  createdate :string;
  hs_num_blockers :string;
  billing_address :string;
  shipping_address_2 :string;
  hs_total_deal_value :string;
  billing_postal_code :string;
  hubspot_owner_id :string;
  first_deal_created_date :string;
  shipping_state_region :string;
  hs_created_by_user_id :string;
  business_type :string;
  billing_address_2 :string;
  num_associated_deals :string;
  hs_annual_revenue_currency_code :string;
  state :string;
  shipping_address :string;
  hs_all_owner_ids :string;
  zip :string;
  hs_num_open_deals :string;
  website :string;
  address :string;
  address2 :string;
  hs_user_ids_of_all_owners :string;
  ein__c :string;
  copy_billing_address_to_shipping_address__c :string;
  billing_city :string;
  hs_target_account_probability :string;
  billing_state_region :string;
  hs_lastmodifieddate :string;
  phone :string;
  hubspot_owner_assigneddate :string;
  hs_num_decision_makers :string;
  domain :string;
  billing_country_region :string;
  name :string;
  hs_object_id :string;
  hs_num_contacts_with_buying_roles :string;
  hs_num_child_companies :string;
  lifecyclestage :string;
  shipping_postal_code :string;
  shipping_country_region :string;
  hs_updated_by_user_id :string;
}

export interface IStoreType {
  id :number;
  storeType :string;
}

export interface IChannelNew {
  id :number;
  label :string;
  description :string;
  warehouseGroupId :number;
  storeType :number;
  pullOrdersFromOms :boolean;
  getProductsEnabled :boolean;
  pushInventoryEnabled :boolean;
  pullStocksEnabled :boolean;
  enabled :boolean;
  status :number;
}

export enum EChannelIntegrationStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILED = 'FAILED',
}

export enum EChannelFilterComparisonOperators {
  EQUALS = 'EQ',
  CONTAINS = 'IN',
}
